module.exports = __webpack_public_path__ + "static/media/Monday_Step1_Image35.be3a45b9.webp";